













import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import {
  ColDef,
  ColumnApi,
  GridApi,
  GridOptions,
  GridReadyEvent,
} from 'ag-grid-community';
import { AgGridVue } from 'ag-grid-vue';
import config from '@/config/index';
import { CotizadorService } from '@/pantallas/SucursalVirtual/Cotizador/CotizadorService';
import { AxiosResponse } from 'axios';
import { MSResponse } from '@/interfaces/MS';
import SucursalVirtuallInstance from '@/pantallas/SucursalVirtual/comunes/instances';
import TorreControlInstance from '@/pantallas/TorreControl/comunes/Instances';

@Component({
  name: 'Datatables',
  components: {
    GridComponent: AgGridVue,
  },
})
export default class Datatable extends Vue {
  @Prop({ default: [] }) headers!: any[];
  loadingService = new LoadingService();
  name: 'Datatables';
  gridOptions: GridOptions;
  cotizadorService = new CotizadorService();
  localeText: any = config.agGridTextos;
  columnDefs: Array<ColDef> = [];
  gridApi: GridApi;
  serverSide: any;
  columnApi: ColumnApi;
  $snotify: any;
  search: string = '';
  filters: any = {};
  dataTable: any = [];
  timer: any = '';

  rowsPerPageItems = [
    10,
    25,
    50,
    100,
    { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
  ];
  pagination = {
    sortBy: 'nom_flota',
    page: 0,
    rowsPerPage: 25,
    totalItems: this.dataTable.length,
  };

  constructor() {
    super();

    this.gridOptions = {
      rowSelection: 'single',
      pagination: true,
      paginationPageSize: 50, //Solución Paginación
      cacheBlockSize: 50, //Solución Paginación //Ordenamiento + Seleccion
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCellSelection: false,
      localeText: this.localeText,
      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      onGridReady: this.onGridReady,
      onCellClicked: (event: any) => {
        /*let data = event.data;
        if (data.patente) {
          this.selectRow(
              `/Torre-Control/dispositivos/${data.avl}/${data.patente}`
          );
        } else {
          this.$snotify.warning('Vehículo sin Patente');
        }*/
      },
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      blockLoadDebounceMillis: 350,
      columnTypes: {},
      suppressCsvExport: false,
      suppressExcelExport: true,
    };
  }

  beforeDestroy() {
    clearInterval(this.timer);
  }

  async onGridReady(params: GridReadyEvent) {
    var self = this;
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.startInterval();

    this.serverSide = {
      async getRows(params: any): Promise<any> {
        params.request.search = self.search;
        params.request.filters = self.filters;
        params.request.paginationSize = self.gridOptions.cacheBlockSize;
        var body: any = {};

        body = Object.assign({}, body, params.request);

        const axiosResponse: AxiosResponse<
          MSResponse<any>
        > = await self.cotizadorService.getCotizaciones(
          localStorage.getItem('clienteDefecto'),
          body
        );
        this.isLoading = false;
        const msResponse: any = axiosResponse.data;
        if (msResponse.CODIGO_RESPUESTA == '1') {
          self.dataTable = msResponse.data;
          params.successCallback(msResponse.data, msResponse.total);
          self.gridApi.hideOverlay();
          SucursalVirtuallInstance.$emit('loadCotizaciones', self.dataTable);
        } else {
          params.successCallback({}, 0);
          self.gridApi.showNoRowsOverlay();
          self.gridApi.setDomLayout('autoHeight');
          SucursalVirtuallInstance.$emit('loadCotizaciones', []);
        }
      },
    };
    SucursalVirtuallInstance.$off('loadData');
    SucursalVirtuallInstance.$off('Export');
    SucursalVirtuallInstance.$off('onFilterChanged');
    SucursalVirtuallInstance.$off('setServerSideDatasource');
    SucursalVirtuallInstance.$off('filterData');
    SucursalVirtuallInstance.$on('loadData', function() {
      self.gridApi.setServerSideDatasource(self.serverSide);
      self.gridApi.setDomLayout('autoHeight');
    });
    SucursalVirtuallInstance.$on('onFilterChanged', function(search: string) {
      self.search = search;
      self.gridApi.onFilterChanged();
      self.gridApi.setDomLayout('autoHeight');
    });
    SucursalVirtuallInstance.$on('setServerSideDatasource', function() {
      self.search = '';
      self.gridApi.setServerSideDatasource(self.serverSide);
    });
    SucursalVirtuallInstance.$on('ExportCotizaciones', () => {
      self.gridApi.exportDataAsCsv({
        fileName: 'Cotizaciones',
        columnKeys: [
          'id',
          'razon_social',
          'rut_cliente',
          'ejecutivo',
          'fecha_creacion',
          'estado',
          'soluciones',
          'url_pdf',
        ],
      });
      self.loadingService.hideLoading();
    });
    SucursalVirtuallInstance.$on('filterData', (formFilters: any) => {
      self.filters = formFilters;
      self.gridApi.onFilterChanged();
      self.gridApi.setDomLayout('autoHeight');
      self.loadingService.hideLoading();
    });
    this.gridApi.setColumnDefs(this.headers);
    this.gridApi.setServerSideDatasource(this.serverSide);
    this.gridApi.setDomLayout('autoHeight');
  }

  startInterval() {
    var self = this;
    this.timer = setInterval(function() {
      self.gridApi.setServerSideDatasource(self.serverSide);
    }, 20000);
  }

  @Watch('headers')
  async watchHeaders() {
    this.gridApi.setColumnDefs(this.headers);
    this.gridApi.refreshHeader();
    this.gridApi.setDomLayout('autoHeight');
  }

  @Watch('dataTable')
  async watchDataTable() {
    this.gridApi.setRowData(this.dataTable);
  }
}
